import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import "animate.css";
import { Fragment, useEffect } from "react";
import PrivateRoute from "./PrivateRoute";
import { getAuth } from "./redux/features/authSlice";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { sideBarLinks } from "./utils/constants";
import NotFound from "./pages/NotFound";
import DashboardLanding from "./pages/Dashboard/DashboardLanding";
import ReportStepOne from "./pages/ReportStepOne";
import AddMine from "./pages/Mines/AddMine";
import AddLogistics from "./pages/LogisticsProviders/AddLogistics";
import AddRefineries from "./pages/Refineries/AddRefineries";
import AddVaults from "./pages/Vaults/AddVaults";
function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleLogOut = async () => {
      try {
        Cookies.remove("accessToken");
        Cookies.remove("testnetaccessToken");
        navigate("/");
        toast.success(
          "Your session has expired. Please log in again to continue"
        );
      } catch (err) {
        toast.error(err.message);
      }
    };

    const setAuth = async () => {
      try {
        const result = dispatch(getAuth());
        if (result?.payload?.response?.data?.message === "Unauthorized") {
          await handleLogOut();
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (Cookies.get(`${process.env.REACT_APP_NETWORK}accessToken`) === "true") {
      setAuth();
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    const cookeiData = Cookies.get(
      `${process.env.REACT_APP_NETWORK}accessToken`
    );
    if (!cookeiData) {
      navigate("/");
    }
  }, [navigate]);
  return (
    <>
      <ToastContainer autoClose={2000} />
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route index path="dashboard" element={<DashboardLanding />}></Route>
          <Route index path="add-mine" element={<AddMine />}></Route>
          <Route index path="add-logistics" element={<AddLogistics />}></Route>
          <Route
            index
            path="/add-refineries"
            element={<AddRefineries />}
          ></Route>
          <Route index path="add-vaults" element={<AddVaults />}></Route>
          <Route
            path="report-first/:nodeId/:date"
            element={<ReportStepOne />}
          ></Route>

          {/* {sideBarLinks.map(
            (item, index) =>
              item.title !== "Dashboard" && (
                <Route
                  key={index}
                  path={item.path}
                  element={<Fragment>{item.component}</Fragment>}
                ></Route>
              )
          )} */}
          {sideBarLinks.map((item, index) => {
            if (item.component === null && item.child) {
              return item.child.map((childItem, childIndex) => (
                <Route
                  key={`${index}-${childIndex}`}
                  path={childItem.path}
                  element={<Fragment>{childItem.component}</Fragment>}
                />
              ));
            } else if (item.title !== "Dashboard") {
              // Render routes for other items except "Dashboard"
              return (
                <Route
                  key={index}
                  path={item.path}
                  element={<Fragment>{item.component}</Fragment>}
                />
              );
            }
            return null;
          })}

          <Route path="*" element={<NotFound />}></Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
